export default "__VITE_ASSET__BUAXN8gd__"